import {AxiosResponse} from "axios";
import Repository from "@/services/Repository";

const resource = '/thongke';

export default new class{
    private Repository: any;
    listDieuTri(dt1: number, dt2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/benhnhan/${dt1}/${dt2}`);
    }
    listDoanhThu(dt1: number, dt2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/doanhthu/${dt1}/${dt2}`);
    }
    doanhThuCungKy(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/doanhthucungky`);
    }
    doanhThuCaNam(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/doanhthucanam`);
    }
    dashboard(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/dashboard`);
    }
    dsdoanhthu(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/dsdoanhthu`);
    }
    dashboardInTime(dt1: number, dt2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/dboard/${dt1}/${dt2}`);
    }
    dashboardCungKy(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/dtcungky`);
    }
    getListDashboardIn10Day(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListDashboardIn10Day`);
    }
    getListDashboardWithRealTime(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListDashboardWithRealTime`);
    }
    dashboardRealTime(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/dashboardRealTime`);
    }
    benhNhanNoiTru(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/benhNhanNoiTru`);
    }
    dashboardDoanhThu(dt1: number, dt2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/dashboardDoanhThu/${dt1}/${dt2}`);
    }
}